/* tslint:disable */
/* eslint-disable */
/**
 * Jen API
 * Jen RESTful APIs, designed to provide easy access to our latest music generation models.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EditMusicTracksDto } from './EditMusicTracksDto';
import {
    EditMusicTracksDtoFromJSON,
    EditMusicTracksDtoFromJSONTyped,
    EditMusicTracksDtoToJSON,
    EditMusicTracksDtoToJSONTyped,
} from './EditMusicTracksDto';

/**
 * 
 * @export
 * @interface EditMusicDto
 */
export interface EditMusicDto {
    /**
     * 
     * @type {number}
     * @memberof EditMusicDto
     */
    folderId?: number;
    /**
     * 
     * @type {string}
     * @memberof EditMusicDto
     */
    format: string;
    /**
     * 
     * @type {string}
     * @memberof EditMusicDto
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof EditMusicDto
     */
    assist: string;
    /**
     * 
     * @type {Array<EditMusicTracksDto>}
     * @memberof EditMusicDto
     */
    tracks: Array<EditMusicTracksDto>;
    /**
     * number of tracks
     * @type {number}
     * @memberof EditMusicDto
     */
    tracksNum?: number;
    /**
     * 
     * @type {number}
     * @memberof EditMusicDto
     */
    styleFilterId?: number;
    /**
     * 
     * @type {number}
     * @memberof EditMusicDto
     */
    filterWeight?: number;
}

/**
 * Check if a given object implements the EditMusicDto interface.
 */
export function instanceOfEditMusicDto(value: object): value is EditMusicDto {
    if (!('format' in value) || value['format'] === undefined) return false;
    if (!('model' in value) || value['model'] === undefined) return false;
    if (!('assist' in value) || value['assist'] === undefined) return false;
    if (!('tracks' in value) || value['tracks'] === undefined) return false;
    return true;
}

export function EditMusicDtoFromJSON(json: any): EditMusicDto {
    return EditMusicDtoFromJSONTyped(json, false);
}

export function EditMusicDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditMusicDto {
    if (json == null) {
        return json;
    }
    return {
        
        'folderId': json['folderId'] == null ? undefined : json['folderId'],
        'format': json['format'],
        'model': json['model'],
        'assist': json['assist'],
        'tracks': ((json['tracks'] as Array<any>).map(EditMusicTracksDtoFromJSON)),
        'tracksNum': json['tracksNum'] == null ? undefined : json['tracksNum'],
        'styleFilterId': json['styleFilterId'] == null ? undefined : json['styleFilterId'],
        'filterWeight': json['filterWeight'] == null ? undefined : json['filterWeight'],
    };
}

export function EditMusicDtoToJSON(json: any): EditMusicDto {
    return EditMusicDtoToJSONTyped(json, false);
}

export function EditMusicDtoToJSONTyped(value?: EditMusicDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'folderId': value['folderId'],
        'format': value['format'],
        'model': value['model'],
        'assist': value['assist'],
        'tracks': ((value['tracks'] as Array<any>).map(EditMusicTracksDtoToJSON)),
        'tracksNum': value['tracksNum'],
        'styleFilterId': value['styleFilterId'],
        'filterWeight': value['filterWeight'],
    };
}

